import { store } from '@/store'
import PropTypes from 'prop-types'
import { useContext, useEffect, useState } from 'react'
import { useFormikContext } from 'formik'
import { ContractSearcherContext } from './context'
import { CompanySelector, ContractSelector } from '@/shared/selectors'
import { contractApi } from '@/store/services'

export const ContractSearcher = ({ name, required = false }) => {
  const { currentContract, updateCurrentContract } = useContext(ContractSearcherContext)
  const { setFieldValue } = useFormikContext()
  const [selectedCompany, setSelectedCompany] = useState({})
  const [selectedContract, setSelectedContract] = useState({})
  const setCurrentContract = updateCurrentContract || (() => {})

  const handleCompanyChange = async (opt = {}) => {
    if (!opt?.value) {
      setSelectedCompany({})
      setSelectedContract({})
      setCurrentContract({})
      setFieldValue(name, null)
      return
    }

    const companyId = opt.value
    setSelectedCompany({ id: companyId })
    setSelectedContract({})
    setCurrentContract({})
    setFieldValue(name, null)

    try {
      const searchParams = new URLSearchParams({
        by_company_id: companyId,
        page: 1,
        per_page: 2
      }).toString()

      const { contracts } = await store
        .dispatch(contractApi.endpoints.getParentsSelectorContracts.initiate(`?${searchParams}`))
        .unwrap()

      if (contracts.length === 1) {
        const contract = contracts[0]
        const option = {
          value: contract.id,
          label: `${contract.id} - ${contract.name} - ${contract.companyName}`,
          resource: contract
        }
        setSelectedContract(option)
        setCurrentContract(contract)
        setFieldValue(name, contract.id)
      }
    } catch (err) {
      console.error('Error fetching contracts for company:', err)
    }
  }

  useEffect(() => {
    if (!currentContract?.id) return

    setSelectedContract({
      value: currentContract.id,
      label: `${currentContract.id} - ${currentContract.name}`,
      resource: currentContract
    })
    setSelectedCompany(currentContract?.company)
    setFieldValue(name, currentContract.id)
  }, [currentContract])

  const handleContractChange = (opt) => {
    if (!opt) {
      setSelectedContract({})
      setCurrentContract({})
      setFieldValue(name, null)
      return
    }

    setSelectedContract(opt)
    setCurrentContract(opt.resource || {})
    setFieldValue(name, opt.value)
  }

  return (
    <>
      <CompanySelector
        required={required}
        onChange={handleCompanyChange}
        value={selectedCompany?.id || null}
      />

      <ContractSelector
        key={selectedCompany?.id || 'default'}
        value={selectedContract?.value || null}
        onChange={handleContractChange}
        query={
          selectedCompany?.id
            ? { by_company_id: selectedCompany.id }
            : { invalid_filter: true }
        }
      />
    </>
  )
}

ContractSearcher.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool
}
